import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase configuration - these should be set in environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Validate Firebase configuration
console.log('🔧 Firebase Configuration Check:');
console.log('API Key:', firebaseConfig.apiKey ? `${firebaseConfig.apiKey.substring(0, 20)}...` : 'MISSING');
console.log('Auth Domain:', firebaseConfig.authDomain || 'MISSING');
console.log('Project ID:', firebaseConfig.projectId || 'MISSING');
console.log('Storage Bucket:', firebaseConfig.storageBucket || 'MISSING');
console.log('Messaging Sender ID:', firebaseConfig.messagingSenderId || 'MISSING');
console.log('App ID:', firebaseConfig.appId ? `${firebaseConfig.appId.substring(0, 20)}...` : 'MISSING');

if (!firebaseConfig.apiKey || !firebaseConfig.projectId || !firebaseConfig.authDomain) {
  console.error('❌ CRITICAL: Firebase configuration is incomplete!');
  console.error('Missing required fields. Please check your environment variables.');
  throw new Error('Firebase configuration is incomplete. Check console for details.');
}

console.log('✅ Firebase configuration validated successfully');

// Initialize Firebase
let app;
let auth;

try {
  app = initializeApp(firebaseConfig);
  console.log('✅ Firebase app initialized');
  
  // Initialize Firebase Authentication
  auth = getAuth(app);
  console.log('✅ Firebase Auth initialized');
  console.log('Current URL:', window.location.href);
  console.log('Auth Domain:', firebaseConfig.authDomain);
} catch (error) {
  console.error('❌ Firebase initialization error:', error);
  throw error;
}

export { auth };
export default app;
